import AttachWorkflowBtn from "./AttachWorkflowBtn";

export default AttachWorkflowBtn;



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/AttachWorkflowBtn/index.js